import { dataService } from '../services/dataService.js';

export function openSearchModal() {
  const modal = document.createElement('div');
  modal.className = 'sheet-backdrop active';
  modal.style.alignItems = 'flex-start';
  modal.style.paddingTop = 'calc(var(--header-height) + 12px)';

  modal.innerHTML = `
    <div class="bottom-sheet" style="max-height: 80vh; transform: scale(1); border-radius: var(--radius-lg); border: 1px solid var(--border-gold);" role="dialog">
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: var(--space-md);">
        <div style="flex: 1; position: relative;">
          <input 
            type="text" 
            id="search-input" 
            placeholder="Search movies, actors, directors (English / සිංහල)..." 
            autocomplete="off"
            style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-strong); border-radius: var(--radius-md); padding: 12px 14px; font-size: 0.95rem; color: var(--text-primary); outline: none;"
          />
        </div>
        <button id="close-search-btn" class="icon-btn" aria-label="Close search">✕</button>
      </div>

      <div id="search-results-area" style="max-height: 55vh; overflow-y: auto;">
        <p style="text-align: center; color: var(--text-muted); font-size: 0.85rem; padding: var(--space-lg) 0;">
          Try typing "Sinhabahu", "සිංහබාහු", "Jackson Anthony", or "Lester"
        </p>
      </div>
    </div>
  `;

  const input = modal.querySelector('#search-input');
  const resultsArea = modal.querySelector('#search-results-area');
  const closeBtn = modal.querySelector('#close-search-btn');

  let debounceTimer = null;

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      const q = input.value.trim();
      if (!q) {
        resultsArea.innerHTML = `
          <p style="text-align: center; color: var(--text-muted); font-size: 0.85rem; padding: var(--space-lg) 0;">
            Try typing "Sinhabahu", "සිංහබාහු", "Jackson Anthony", or "Lester"
          </p>
        `;
        return;
      }

      resultsArea.innerHTML = `<p style="text-align: center; color: var(--text-muted); padding: var(--space-md);">Searching...</p>`;
      const results = await dataService.search(q);

      if (results.length === 0) {
        resultsArea.innerHTML = `
          <div style="text-align: center; padding: var(--space-xl) var(--space-md); color: var(--text-muted);">
            <p style="font-size: 0.95rem; margin-bottom: 4px;">No matching titles or cast members found.</p>
            <p style="font-size: 0.8rem;">Check spelling or try Singlish keywords.</p>
          </div>
        `;
        return;
      }

      resultsArea.innerHTML = `
        <div style="display: flex; flex-direction: column; gap: var(--space-xs);">
          ${results.map(item => {
            const isMovie = item.type === 'movie';
            const linkHref = isMovie ? `#/movie/${item.id}` : `#/person/${item.id}`;
            const imgUrl = isMovie ? item.poster : item.avatar;
            const subText = isMovie 
              ? `${item.year} • Dir: ${item.director}` 
              : (item.role || 'Artist');

            return `
              <a href="${linkHref}" class="song-card search-result-item clickable-item" style="padding: 8px 12px;">
                <img src="${imgUrl}" alt="${item.title}" style="width: 44px; height: 58px; object-fit: cover; border-radius: var(--radius-xs);" />
                <div class="song-info">
                  <div style="font-size: 0.92rem; font-weight: 700;">${item.title}</div>
                  <div style="font-size: 0.78rem; color: var(--accent-gold);">${item.sinhalaTitle || ''}</div>
                  <div style="font-size: 0.75rem; color: var(--text-muted);">${subText}</div>
                </div>
                ${isMovie && item.rating ? `
                  <div class="badge-pill badge-gold" style="font-size: 0.72rem; padding: 2px 8px;">★ ${item.rating}</div>
                ` : ''}
              </a>
            `;
          }).join('')}
        </div>
      `;

      modal.querySelectorAll('.search-result-item').forEach(item => {
        item.addEventListener('click', close);
      });
    }, 200);
  });

  function close() {
    modal.classList.remove('active');
    setTimeout(() => modal.remove(), 200);
  }

  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });

  document.body.appendChild(modal);
  setTimeout(() => input.focus(), 50);
}
